import myAxios from "./axiositeachWrapper";
import Config from "../_config/config";

export interface Assignment {
  Id?: number;
  Title: string;
  Instructions?: string;
  ResponseType: "TEXT" | "FILE" | "TEXT_AND_FILE" | "QUESTIONS";
  MaxScore?: number;
  MaxAttempts?: number;
  AllowLateSubmission?: number;
  RubricId?: number;
  Config?: Record<string, any>;
  CourseId?: number;
  SubjectTagId?: number;
  StudyResourceId?: number;
  CreatedByUserId?: number;
  CreatedByName?: string;
  CourseName?: string;
  CreationDate?: string;
  IssueCount?: number;
  ResourceCount?: number;
  QuestionCount?: number;
  resources?: AssignmentResource[];
  questions?: AssignmentQuestionDef[];
}

export interface AssignmentResource {
  mappingId?: number;
  resourceId: number;
  resourceName?: string;
  resourceTypeId?: number;
  resourceTypeName?: string;
  resourceUrl?: string;
  sortOrder: number;
  label?: string;
}

export interface AssignmentQuestionDef {
  Id?: number;
  questionText?: string;
  questionType: "SHORT_ANSWER" | "ESSAY" | "PARAGRAPH";
  questionId?: number;
  maxScore?: number;
  sortOrder: number;
  required?: boolean;
  config?: Record<string, any>;
  // From question bank join
  QuestionBankText?: string;
  option1?: string;
  option2?: string;
  option3?: string;
  option4?: string;
  option5?: string;
  correctAnswer?: string;
}

export interface AssignmentSubmission {
  Id: number;
  UserId: number;
  StudentName?: string;
  StudentUsername?: string;
  Status: string;
  SubmittedAt?: string;
  GradedAt?: string;
  ReturnedAt?: string;
  Score?: string;
  MaxScore?: string;
  PercentageScore?: string;
  Grade?: string;
  IsLate?: number;
  FeedbackText?: string;
  ReviewerComments?: string;
  SubmissionData?: any;
  SubmissionText?: string;
  AttachmentURL?: string;
  AttemptNumber?: number;
}

const BASE = `${Config.nodeSiteUrl}v1/assignments`;

class AssignmentService {
  getAll(params?: {
    courseId?: number;
    search?: string;
    limit?: number;
    offset?: number;
  }) {
    const query = new URLSearchParams();
    if (params?.courseId) query.set("courseId", String(params.courseId));
    if (params?.search) query.set("search", params.search);
    if (params?.limit) query.set("limit", String(params.limit));
    if (params?.offset) query.set("offset", String(params.offset));
    return myAxios.get(`${BASE}?${query.toString()}`);
  }

  getById(id: number) {
    return myAxios.get(`${BASE}/${id}`);
  }

  create(data: any) {
    return myAxios.post(BASE, data);
  }

  update(id: number, data: any) {
    return myAxios.put(`${BASE}/${id}`, data);
  }

  delete(id: number) {
    return myAxios.delete(`${BASE}/${id}`);
  }

  getSubmissions(assignmentId: number, params?: { status?: string }) {
    const query = new URLSearchParams();
    if (params?.status) query.set("status", params.status);
    return myAxios.get(
      `${BASE}/${assignmentId}/submissions?${query.toString()}`
    );
  }

  gradeSubmission(
    assignmentId: number,
    submissionId: number,
    data: {
      score?: number;
      maxScore?: number;
      feedbackText?: string;
      grade?: string;
      reviewerComments?: string;
    }
  ) {
    return myAxios.patch(
      `${BASE}/${assignmentId}/submissions/${submissionId}/grade`,
      data
    );
  }

  returnSubmission(
    assignmentId: number,
    submissionId: number,
    data: { feedbackText?: string; reviewerComments?: string }
  ) {
    return myAxios.patch(
      `${BASE}/${assignmentId}/submissions/${submissionId}/return`,
      data
    );
  }
}

export default new AssignmentService();
